import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import workerAcceptStatusSound from '../../assets/sounds/worker-accept.mp3';
import workerInWayStatusSound from '../../assets/sounds/worker-in-way.mp3';
import workerWorkingStatusSound from '../../assets/sounds/worker-working.mp3';
import workerPerformingStatusSound from '../../assets/sounds/worker-performing.mp3';
import workerFinishStatusSound from '../../assets/sounds/worker-finish.mp3';

import { SERVER_NOTS, getSSENotify, hideNotify } from '../../redux/notifySlice';


export const Notifications = () => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth);
    useEffect(() => {
        // const eventSource = new EventSource(`http://localhost:5001/sse/${user.sseId}`);
        const eventSource = new EventSource(`http://185.233.186.19:81/sse/${user.sseId}`);

        eventSource.onmessage = (event) => {
            const bodyData = JSON.parse(event.data);
            console.log(bodyData)
            dispatch(getSSENotify(bodyData));
        };
        return () => {
            eventSource.close();
        };

    }, []);

    const notices = useSelector((state) => state.notify.list).filter((notify) => !notify.isViewed);
    return (
        <div className="notify-wrapper">
            {notices.map((notice, index) => (
                <Notify {...notice} key={index} />
            ))}
        </div>
    );
};

const Notify = ({ id, title, text, success, action }) => {
    const dispatch = useDispatch();
    const closeNotifyHandler = () => {
        dispatch(hideNotify(id));
    };

    const defineSound = (action) => {
        switch (action) {
            case SERVER_NOTS.WORKER_ACCEPT_ORDER: {
                return workerAcceptStatusSound;
            }
            case SERVER_NOTS.WORKER_IN_WAY: {
                return workerInWayStatusSound;
            }
            case SERVER_NOTS.WORKER_WORKING: {
                return workerWorkingStatusSound;
            }
            case SERVER_NOTS.WORKER_PERFORM: {
                return workerPerformingStatusSound;
            }
            case SERVER_NOTS.WORKER_FINISHING: {
                return workerFinishStatusSound;
            }
            default:
                return null;
        }
    };
    const soundSrc = defineSound(action);
    const audioRef = useRef(null);

    useEffect(() => {
        // Воспроизведение звука при монтировании компонента (при появлении уведомления)
        if (soundSrc) {
            try {
                audioRef.current?.play();
            } catch (error) {
                console.log('Воспроизведение звука:', error);
            }
        }
    }, []);
    return (
        <div className={`notify ${success ? 'success' : 'error'}`}>
            <audio ref={audioRef} src={soundSrc} preload="auto"></audio>
            <div className="notify__header">
                <h3 className="notify__title">{title}</h3>
                <div className="notify__close-button" onClick={closeNotifyHandler}>
                    x
                </div>
            </div>
            <div className="notify__body">
                <div className="notify__text">{text}</div>
            </div>
        </div>
    );
};
